/**
 * @desc 导出线下销售订单明细
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(boOrderNo: string, options?: any) {
  return updateResponse(
    http(URL + `/customerOrder/exportOfflineOrders/${boOrderNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
